import { IconLogout } from "@tabler/icons-react";
import classes from "../NavbarSimple/NavbarSimple.module.css";
import { UserInfoAction } from "./UserInfoAction/UserInfoAction";
import MerchModal from "./MerchModal/MerchModal";

export default function ProfileSection() {
  const redirectURL = window.location.origin + "/app/";

  function handleLogout() {
    window.catalyst.auth.signOut(redirectURL);
  }

  return (
    <>
      <UserInfoAction/>
      <MerchModal />
      <a href="#" className={classes.link} onClick={handleLogout}>
        <IconLogout className={classes.linkIcon} stroke={1.5} />
        <span>Logout</span>
      </a>
    </>
  );
}
